export default {
    title: 'Obsługi',
    every: 'co {n} mies.',
    everyKm: 'co {km} km',
    everyOr: '{months} lub {km} km',
    once: 'jednorazowa',
    everyLabel: 'Co ile',
    everyKmLabel: 'Co ile km (opcjonalnie)',
    km: {
        left: 'zostało ~{km} km',
        over: '{km} km po progu',
        at: 'przy {km} km',
        noData: 'termin po km policzy się z pomiarów przebiegu',
    },
    name: 'Nazwa obsługi',
    last: 'ostatnio {date}',
    never: 'jeszcze nie zrobiona',
    next: 'Następnie {when} · {date}',
    manual: 'ustawiony ręcznie',
    noTerm: 'bez terminu',
    noTermYet: 'termin po pierwszym „Zrobione"',
    setDue: 'Zmień termin',
    fromLog: 'Licz od wykonania',
    done: 'Zrobione',
    edit: 'Zmień obsługę „{name}"',
    remove: 'Usuń obsługę „{name}"',
    removed: 'Usunięto obsługę „{name}"',
    undo: 'Cofnij',
    save: 'Zapisz',
    cancel: 'Anuluj',
    close: 'Zamknij',
    history: 'Historia ({n})',
    editLog: 'Popraw wykonanie',
    removeLog: 'Usuń wykonanie',
    removeLogAsk: 'To wykonanie ma wydatek w Portfelu. Usunąć też wydatek?',
    removeLogWithExpense: 'Usuń z wydatkiem',
    removeLogOnly: 'Tylko wykonanie',
    inWallet: 'w Portfelu',
    logDocuments: 'Dokumenty wykonania: {n}',
    add: 'Dodaj obsługę',
    addSave: 'Dodaj',
    suggestionsTitle: 'Podpowiedzi',
    customPlaceholder: 'Własna nazwa, np. Wymiana filtra',
    empty: {
        pet: 'Szczepienie, odrobaczanie, kleszcze — dodaj, co trzeba robić regularnie, a termin przypomni się w „Teraz" i w Planerze.',
        device: 'Przegląd, wymiana filtra, odkamienianie — dodaj, co trzeba robić regularnie, a termin przypomni się w „Teraz" i w Planerze.',
    },
    form: {
        date: 'Dzień',
        cost: 'Koszt',
        note: 'Notatka (opcjonalnie)',
        km: 'Licznik (km)',
        addExpense: 'Dodaj do Portfela jako wydatek',
        saveDone: 'Zapisz wykonanie',
    },
    documents: {
        title: 'Dokumenty',
        empty: 'Książka szczepień, karta gwarancyjna, faktura z serwisu — zdjęcie albo PDF.',
        camera: 'Zrób zdjęcie',
        file: 'Dodaj plik',
        uploading: 'Wysyłam…',
        open: 'Otwórz „{name}"',
        rename: 'Zmień tytuł',
        titlePlaceholder: 'Tytuł, np. Książka szczepień',
        remove: 'Usuń dokument „{name}"',
        removed: 'Usunięto dokument „{name}"',
        fromLog: '{care} · {date}',
        addFailed: 'Nie udało się dodać pliku.',
        tooLarge: 'Plik jest za duży (maks. 20 MB).',
        unsupported: 'Dozwolone są zdjęcia (JPG, PNG, WebP) i PDF.',
        openFailed: 'Nie udało się otworzyć pliku.',
    },
    when: {
        today: 'dziś',
        tomorrow: 'jutro',
        inDays: 'za {n} dzień | za {n} dni | za {n} dni',
        late: '{n} dzień po terminie | {n} dni po terminie | {n} dni po terminie',
    },
    badge: '{when} · {what}',
    planner: '{icon} {subject}: {name}',
    suggestions: {
        vaccine: 'Szczepienie',
        deworming: 'Odrobaczanie',
        ticks: 'Kleszcze i pchły',
        vet: 'Weterynarz – kontrola',
        grooming: 'Strzyżenie',
        claws: 'Pazury',
        inspection: 'Przegląd techniczny',
        insurance: 'OC',
        oil: 'Wymiana oleju',
        timing: 'Rozrząd',
        tyres: 'Opony zima/lato',
        descaling: 'Odkamienianie',
        filter: 'Filtr',
        service: 'Serwis',
    },
};
